import styled from 'src/style';

const GreyBackground = styled.div({
  backgroundColor: 'red',
  //width: 1500,
  left: 0,
  right: 0,
  marginTop: '-140px',
  top: '50%',
  position: 'absolute',
  zIndex: 3,
});

export default GreyBackground;
